import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard/index";
import SettingsPage from "../feautures/settings/pages/SettingsPage";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import SelfRegisterPage from "../pages/Authentication/SelfRegisterPage";

import UserProfile from "../pages/Authentication/user-profile";
import ResponsiveTables from "../pages/Tables/UsersTable";
import CompaniesTable from "../pages/Tables/CompanyTable";
import PaymentHistoryTable from "../pages/Tables/PaymentHistoryTable";
import RefundHistoryTable from "../pages/Tables/RefundHistoryTable";
//import PaymentForm from "../pages/modals/payment/PaymentForm";
import PaymentForm from "../pages/modals/payment/newPaymentForm/PaymentForm";
//import InstantPaymentPage from "../pages/modals/payment/InstantPaymentForm";
import InstantPaymentPage from "../pages/modals/payment/newInsantPaymentForm/InstantPaymentForm";
import AccountsTable from "../pages/Tables/AccountTable";
import PaymentLinkTable from "../pages/Tables/PaymentLinkTable";
import AnlikOdemeBasarili from "../pages/modals/payment/InstantPaymentSuccessPage";
import AnlikOdemeBasarisiz from "../pages/modals/payment/InstantPaymentFailedPage";
import OdemeBasarili from "../pages/modals/payment/PaymentSuccessPage";
import OdemeBasarisiz from "../pages/modals/payment/PaymentFailedPage";
import CompanyWelcomePage from "../pages/modals/company/CompanyWelcomePage";
import ScheduledReportCreateModal from "../pages/modals/report/ScheduledReportCreateModal"
import ScheduledReportsTable from "../pages/Tables/ScheduledReportsTable"
import AccountDetailPage from "../pages/accounts/AccountDetailPage"
import EditAccountPage from "../pages/accounts/EditAccountPage"
import CreateUserModal from "../pages/modals/users/UserCreateModal"
import CreateUserPage from "../pages/users/UserCreatePage"
import EditUserPage from "../pages/users/EditUserPage"
import CompanyCreatePage from "../pages/company/CompanyCreatePage"
import CompanyEditPage from "../pages/company/CompanyEditPage"
import CompanyDetailPage from "../pages/company/CompanyDetailPage"
import UserDetailPage from "../pages/users/UserDetailPage"
import CreateAccountPage from "../feautures/account-list/app/CreateAccountPage"
import InstantPaymentCreatePage from "../pages/payment/PaymentLinkCreatePage"
import PaymentLinkCreatePage from "../pages/payment/PaymentLinkCreatePage"
import PaymentLinkDetailPage from "../pages/payment/PaymentLinkDetailPage"
import PaymentDetailPage from "../pages/payment/PaymentDetailPage"
import InvoiceTrackingTable from "../pages/Tables/InvoiceTrackingTable"
import DebtPaymentDetailPage from "../pages/accounts/DebtPaymentDetailPage"
import RegistrationRequestsTable from "../pages/Tables/RegistrationRequestsTable"
import RegistrationRequestDetailPage from "../pages/registration/RegistrationRequestDetailPage"
import MyTicketsPage from "../pages/Support/MyTicketsPage"
import TicketDetailPage from "../pages/Support/TicketDetailPage"
import AdminTicketsPage from "../pages/Admin/AdminTicketsPage"

// Subscription
import PlanSelection from "../pages/Subscription/PlanSelection"
import PlanComparison from "../pages/Subscription/PlanComparison"
import Checkout from "../pages/Subscription/Checkout"
import SubscriptionDetails from "../pages/Subscription/SubscriptionDetails"
import SubscriptionHistory from "../pages/Subscription/SubscriptionHistory"
import UpgradePreview from "../pages/Subscription/UpgradePreview"
import SubscriptionPaymentSuccess from "../pages/Subscription/SubscriptionPaymentSuccess"
import SubscriptionPaymentFail from "../pages/Subscription/SubscriptionPaymentFail"

// Admin Subscription
import SubscriptionPlans from "../pages/Admin/SubscriptionPlans"
import SubscriptionPlanForm from "../pages/Admin/SubscriptionPlanForm"
import CouponCodes from "../pages/Admin/CouponCodes"
import CouponDetailPage from "../pages/Admin/CouponDetailPage"
import PriceOverrides from "../pages/Admin/PriceOverrides"
import Announcements from "../pages/Admin/Announcements"
import SubscriptionDashboard from "../pages/Admin/SubscriptionDashboard"
import SubscriptionDetailPage from "../pages/Admin/SubscriptionDetailPage"
import POSAnalysisDashboard from "../pages/Admin/POSAnalysisDashboard"
import PosProviderCompaniesPage from "../pages/Admin/PosReport/PosProviderCompaniesPage"
import PosCompanyDetailPage from "../pages/Admin/PosReport/PosCompanyDetailPage"

const userRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard/> },

  //profile
  { path: "/profile", component: <UserProfile/> },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },

  { path: "/users", component: <ResponsiveTables/> },
  { path: "/users/create", component: <CreateUserPage/> },
  { path: "/accounts/create", component: <CreateAccountPage/> },
  { path: "/users/:id/edit", component: <EditUserPage /> },
  { path: "/accounts", component: <AccountsTable/> },
  { path: "/companies", component: <CompaniesTable/> },
  { path: "/companies/create", component: <CompanyCreatePage/> },

  { path: "/payment", component: <PaymentForm/> },
  { path: "/payment/:id", component: <PaymentDetailPage/> },
  { path: "/settings", component: <SettingsPage/> },
  { path: "/payment-history", component: <PaymentHistoryTable/> },
  { path: "/refund-history", component: <RefundHistoryTable/> },
  { path: "/invoice-tracking", component: <InvoiceTrackingTable/> },
  { path: "/invoice-tracking/:debtId", component: <DebtPaymentDetailPage/> },
  { path: "/registration-requests", component: <RegistrationRequestsTable/> },
  { path: "/registration-requests/:id", component: <RegistrationRequestDetailPage/> },
  { path: "/support", component: <MyTicketsPage/> },
  { path: "/support/:id", component: <TicketDetailPage/> },
  { path: "/admin/tickets", component: <AdminTicketsPage/> },
  { path: "/admin/tickets/:id", component: <TicketDetailPage admin/> },
  { path: "/schedule-reports", component: <ScheduledReportsTable/> },
  { path: "/payment-links", component: <PaymentLinkTable/> },
  { path: "/payment-links/:id", component: <PaymentLinkDetailPage/> },
  { path: "/payment-links/create/:companyId", component: <InstantPaymentCreatePage/> },
  { path: "/payment-success", component: <OdemeBasarili/> },
  { path: "/payment-failed", component: <OdemeBasarisiz/> },
  {
    path: "/accounts/:id",
    component: <AccountDetailPage />,
    exact: true,
  },

  {
    path: "/accounts/:id/edit",
    component: <EditAccountPage />,
    exact: true,
  },
  {
    path: "/companies/:id/edit",
    component: <CompanyEditPage />,
    exact: true,
  },
  {
    path: "/companies/:id",
    component: <CompanyDetailPage />,
    exact: true,
  },
  {
    path: "/users/:id",
    component: <UserDetailPage />,
    exact: true,
  },

  // Subscription - Company Admin
  { path: "/subscription/details", component: <SubscriptionDetails /> },
  { path: "/subscription/plans", component: <PlanSelection /> },
  { path: "/subscription/compare", component: <PlanComparison /> },
  { path: "/subscription/upgrade/:planId", component: <UpgradePreview /> },
  { path: "/subscription/checkout/:planId", component: <Checkout /> },
  { path: "/subscription/history", component: <SubscriptionHistory /> },
  { path: "/subscription/payment-success", component: <SubscriptionPaymentSuccess /> },
  { path: "/subscription/payment-fail", component: <SubscriptionPaymentFail /> },

  // Subscription - Super Admin
  { path: "/admin/subscription-dashboard", component: <SubscriptionDashboard /> },
  { path: "/admin/subscription-detail/:companyId", component: <SubscriptionDetailPage /> },
  { path: "/admin/subscription-plans", component: <SubscriptionPlans /> },
  { path: "/admin/subscription-plans/new", component: <SubscriptionPlanForm /> },
  { path: "/admin/subscription-plans/:id/edit", component: <SubscriptionPlanForm /> },
  { path: "/admin/coupon-codes", component: <CouponCodes /> },
  { path: "/admin/announcements", component: <Announcements /> },
  { path: "/admin/coupon-codes/:id", component: <CouponDetailPage /> },
  { path: "/admin/price-overrides", component: <PriceOverrides /> },
  // POS Rapor hiyerarşisi:
  // POS Rapor → POS Sağlayıcı → Firmalar → Firma → (İşlem Detayı | Cariler → Cari → İşlem Detayı)
  { path: "/admin/pos-raporu", component: <POSAnalysisDashboard /> },
  { path: "/admin/pos-raporu/:provider", component: <PosProviderCompaniesPage /> },
  // Firma detayı iki sekmelidir (Cari Bazlı / İşlem Bazlı); eski /cariler ve
  // /islemler adresleri ilgili sekmeye yönlendirilir.
  { path: "/admin/pos-raporu/:provider/:companyId", component: <PosCompanyDetailPage /> },
  { path: "/admin/pos-raporu/:provider/:companyId/cariler", component: <PosCompanyDetailPage /> },
  { path: "/admin/pos-raporu/:provider/:companyId/islemler", component: <PosCompanyDetailPage defaultTab="islem" /> },

  // Eski POS ekranlarının adresleri — yer imleri / dış linkler kırılmasın diye yönlendirilir.
  { path: "/admin/pos-analytics", component: <Navigate to="/admin/pos-raporu" replace /> },
  { path: "/admin/pos-analiz", component: <Navigate to="/admin/pos-raporu" replace /> },
];

const authRoutes = [
  //authencation page
  { path: "/logout", component: <Logout/> },
  { path: "/login", component: <Login/> },
  { path: "/forgot-password", component: <ForgetPwd/> },
  { path: "/register", component: <SelfRegisterPage/> },
  { path: "/instant-payment", component: <InstantPaymentPage/> },
  { path: "/odeme/:linkId", component: <InstantPaymentPage/> },
  { path: "/instant-payment-success", component: <AnlikOdemeBasarili/> },
  { path: "/instant-payment-failed", component: <AnlikOdemeBasarisiz/> },
  { path: "/welcome", component: <CompanyWelcomePage/> },


];

export { userRoutes, authRoutes };
